import Icon from '../components/Icon.vue'

Icon.register({
  'reply-all': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M136.3 189.8l176-152c15.4-13.3 39.7-2.5 39.7 18.2v82.8c129.2 10.2 224 52.2 224 183.5 0 61.4-39.6 122.3-83.3 154.1-13.7 9.9-33.1-2.5-28.1-18.6 38.5-123.2-3.9-169.5-112.6-182v84.2c0 20.7-24.3 31.5-39.7 18.2l-176-152c-11.1-9.6-11.1-26.8 0-36.3zM8.3 226.2c-11.1-9.6-11.1-26.8 0-36.3l176-152c15.4-13.3 39.7-2.5 39.7 18.2v15.8l-108.6 93.8c-10.7 9.2-19.4 28.2-19.4 42.4v0 0c0 14.1 8.7 33.1 19.4 42.4l108.6 93.8v15.8c0 20.7-24.3 31.5-39.7 18.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/reply-all.js
// module id = 1836
// module chunks = 0